<template>
	<div class="px-3 mt-4" >
        <h6 class="font-weight-bold"> List of Admins</h6>

        <vue-bootstrap4-table
            :rows="rows"
            :columns="columns"
            :config="config">
         
            <template slot="id" slot-scope="props">
                <span>
                    {{props.row.vbt_id}}
                </span>
            </template>
            <template slot="adminType" slot-scope="props">
                <span>
                    {{(props.cell_value == 1)?'Super Admin':'Admin'}}
                </span>
            </template>

			<template slot="action" slot-scope="props">
				<button type="button" @click="$emit('assignadmin', props.cell_value)" class="btn btn-sm btn-primary">
					Assign Menu
				</button>   
			</template>

            <template slot="sort-asc-icon">
                <i class="fas fa-sort-up"></i>
            </template>
            <template slot="sort-desc-icon">
                <i class="fas fa-sort-down"></i>
            </template>
            <template slot="no-sort-icon">
                <i class="fas fa-sort"></i>
            </template>
        </vue-bootstrap4-table>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import VueBootstrap4Table from 'vue-bootstrap4-table';

export default {
	name: "AdminList",

	components:{
		VueBootstrap4Table
	},

	props: ['rows'],

	computed:{
        ...mapState(['token'])
    },

	data(){
		return {
            columns: [
                {
                    label: "S/N",
                    name: "id",
                    slot_name: "id"
                },
                {
                    label: "Admin ID",
                    name: "adminId",
                    sort: true,
				},
				{
                    label: "First Name",
                    name: "firstName",
                    sort: true,
                },
                {
                    label: "Last Name",
                    name: "lastName",
                    sort: true,
				},
				{
                    label: "Email",
                    name: "email",
                    sort: true,
                },
                {
                    label: "Admin type",
                    name: "adminType",
                    slot_name: "adminType",
                    sort: true,
                },
                {
                    label: "Action",
                    name: "id",
                    slot_name: "action",
                },
            
            ],
            config: {
                card_mode: false,
                show_refresh_button: false,
                show_reset_button: false,
                global_search: {
                    placeholder: "Search Admin",
                    visibility: true,
                    case_sensitive: false,
                },
            }
		}
	},

    methods:{

    }
}
</script>